import { DateTime } from 'luxon';

export type Granularity = 'hour' | 'day';

export type DateInterval = 'today' | 'last7Days' | 'last30Days' | 'custom';

type ChartInterval = {
  value: DateInterval;
  title: string;
  date: { from: number; to: number };
};

type ChartGranularity = { title: string; value: Granularity };

export const START_OF_DAY = { hour: 0, minute: 0, second: 0, millisecond: 0 };
export const END_OF_DAY = { hour: 23, minute: 59, second: 59, millisecond: 0 };

export const TODAY = DateTime.fromJSDate(new Date()).set(START_OF_DAY);

export const PREV_WEEK = DateTime.fromJSDate(new Date())
  .minus({ day: 7 })
  .set(START_OF_DAY);

export const PREV_MONTH = DateTime.fromJSDate(new Date())
  .minus({ day: 30 })
  .set(START_OF_DAY);

export const CHART_INTERVAL: ChartInterval[] = [
  {
    value: 'today',
    title: 'page.stats.interval.today',
    date: {
      from: TODAY.toMillis(),
      to: TODAY.toMillis(),
    },
  },
  {
    value: 'last7Days',
    title: 'page.stats.interval.last7Days',
    date: {
      from: PREV_WEEK.toMillis(),
      to: TODAY.toMillis(),
    },
  },
  {
    value: 'last30Days',
    title: 'page.stats.interval.last30Days',
    date: {
      from: PREV_MONTH.toMillis(),
      to: TODAY.toMillis(),
    },
  },
  {
    value: 'custom',
    title: 'page.stats.interval.custom',
    date: {
      from: PREV_MONTH.toMillis(),
      to: TODAY.toMillis(),
    },
  },
];

export const CHART_GRANULARITY: ChartGranularity[] = [
  {
    title: 'page.stats.granularity.byHour',
    value: 'hour',
  },
  { title: 'page.stats.granularity.byDay', value: 'day' },
];
